module.exports = __webpack_public_path__ + "static/media/light.af5d24b1.jpeg";